module.exports = __webpack_public_path__ + "static/img/service.c0cf66c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service.png
// module id = M8mE
// module chunks = 1